import {SafeHTML} from '@/components/atoms';
import {Text as EdsText, TextProps as EdsTextProps} from '@eds-web/react/Text';
import {TextFieldsFragment} from '@common/hygraph-schema';
import {useFormatHtml} from './Text.utils';

export type TextProps = TextFieldsFragment & Omit<Partial<EdsTextProps>, 'color'>;

export const Text = ({
	ukey,
	textVariant,
	html,
	variant,
	className = 'nested-link-secondary',
	...textProps
}: TextProps) => {
	const __html = useFormatHtml(html);

	if (!html) {
		return null;
	}

	return (
		<EdsText {...textProps} key={ukey} className={className} variant={variant || textVariant}>
			<SafeHTML
				dangerouslySetInnerHTML={{
					__html: __html
				}}
			/>
		</EdsText>
	);
};
